module.exports = __webpack_public_path__ + "img/app-spiagge.650efea5.png";